// PUBLIC
export const BASE_URL = "https://bot.investorium.org:8443";
export const TON_WALLET_ADDRESS = "UQDspvubwgTJW4gqsmJYinQS7E_YAZkzg2fyH_y3JbRuP76W"

// PAGE
export const PAGE_SETTED = "PAGE_SETTED";

//PAGES
export const PAGE_HOME = "PAGE_HOME";
export const PAGE_CHECK_WALLET = "PAGE_CHECK_WALLET";
export const PAGE_TOKEN_ANALYZER = "PAGE_TOKEN_ANALYZER";
export const PAGE_AI_ANALYTICS = "PAGE_AI_ANALYTICS";
export const PAGE_SELECT_BLOCKCHAIN = "PAGE_SELECT_BLOCKCHAIN";
export const PAGE_USER_AREA = "PAGE_USER_AREA";
export const PAGE_UPGRADE = "PAGE_UPGRADE";
export const TAB_AVAILABLE = "TAB_AVAILABLE";
export const TAB_COMING_SOON = "TAB_COMING_SOON";

//INDICATORS
export const RED = "RED";
export const ORANGE = "ORANGE";
export const YELLOW = "YELLOW";
export const EMERALD = "EMERALD";
export const GREEN = "GREEN";

//WALLET STATS TYPE
export const WALLET_PROFIT = "WALLET_PROFIT";
export const WALLET_PNL = "WALLET_PNL";
export const WALLET_WIN_RATE = "WALLET_WIN_RATE";
export const WALLET_TRADES = "WALLET_TRADES";
export const WALLET_AVERAGE_TRADE_TIME = "WALLET_AVERAGE_TRADE_TIME";
export const WALLET_AVERAGE_BUY_VOLUME = "WALLET_AVERAGE_BUY_VOLUME";

//CHECK WALLET STATUS TYPES
export const CHECK_WALLET_WELCOME = "CHECK_WALLET_WELCOME";
export const CHECK_WALLET_STATS = "CHECK_WALLET_STATS";
export const CHECK_WALLET_STATS_SETTED = "CHECK_WALLET_STATS_SETTED";
export const CHECK_WALLET_STATS_PROCESSING = "CHECK_WALLET_STATS_PROCESSING";
export const CHECK_WALLET_PROCESSING = "CHECK_WALLET_PROCESSING";
export const CHECK_WALLET_ERROR = "CHECK_WALLET_ERROR";
export const CHECK_WALLET_PROCESSING_SETTED = "CHECK_WALLET_PROCESSING_SETTED";
export const CHECK_WALLET_ERROR_SETTED = "CHECK_WALLET_ERROR_SETTED";
export const TOKEN_ANALYZER_STATS_PROCESSING = "TOKEN_ANALYZER_STATS_PROCESSING";
export const TOKEN_ANALYZER_PROCESSING_SETTED = "TOKEN_ANALYZER_PROCESSING_SETTED";
export const TOKEN_ANALYZER_PROCESSING = "TOKEN_ANALYZER_PROCESSING";

//WALLET PAGES
export const WALLET_TAB_STATS = "WALLET_TAB_STATS";
export const WALLET_TAB_TOKENS = "WALLET_TAB_TOKENS";
export const WALLET_TAB_BALANCE = "WALLET_TAB_BALANCE";
export const WALLET_TAB_AI_STATS = "WALLET_TAB_AI_STATS";

//TOKEN ANALYZER PAGES
export const TOKEN_ANALYZER_STATS = "TOKEN_ANALYZER_STATS";
export const TOKEN_ANALYZER_WALLETS = "TOKEN_ANALYZER_WALLETS";
export const TOKEN_ANALYZER_AI_STATS = "TOKEN_ANALYZER_AI_STATS";
export const TOKEN_ANALYZER_WELCOME = "TOKEN_ANALYZER_WELCOME";
export const TOKEN_ANALYZER_STATS_SETTED = "TOKEN_ANALYZER_STATS_SETTED";

//TOKEN STATS TYPE
export const TOKEN_NAME = "TOKEN_NAME";
export const TOKEN_WALLETS = "TOKEN_WALLETS";
export const TOKEN_TRANSACTIONS = "TOKEN_TRANSACTIONS";
export const TOKEN_TRADES = "TOKEN_TRADES";
export const TOKEN_AVERAGE_TRADE_TIME = "TOKEN_AVERAGE_TRADE_TIME";
export const TOKEN_AVERAGE_BUY_VOLUME = "TOKEN_AVERAGE_BUY_VOLUME";
export const TOKEN_PNL = "TOKEN_PNL";

//AI CIRCLE
export const AI_FIRST_WELCOME = "FIRST_WELCOME";
export const AI_CHECK_WALLET_WELCOME = "AI_CHECK_WALLET_WELCOME";
export const AI_CHECK_WALLET_WELCOME_SETTED = "AI_CHECK_WALLET_WELCOME_SETTED";
export const AI_FIRST_WELCOME_SETTED = "AI_FIRST_WELCOME_SETTED";
export const AI_TOKEN_ANALYZER_WELCOME = "AI_TOKEN_ANALYZER_WELCOME";
export const AI_TOKEN_ANALYZER_WELCOME_SETTED = "AI_TOKEN_ANALYZER_WELCOME_SETTED";
export const AI_CHECK_WALLET_ERROR = "AI_CHECK_WALLET_ERROR";
export const AI_CHECK_WALLET_PROCESSING = "AI_CHECK_WALLET_PROCESSING";
export const AI_CHECK_WALLET_ERROR_SETTED = "AI_CHECK_WALLET_ERROR_SETTED";
export const AI_CHECK_WALLET_PROCESSING_SETTED = "AI_CHECK_WALLET_PROCESSING_SETTED";
export const AI_TOKEN_ANALYZER_ERROR = "AI_TOKEN_ANALYZER_ERROR";
export const AI_TOKEN_ANALYZER_PROCESSING = "AI_TOKEN_ANALYZER_PROCESSING";
export const AI_TOKEN_ANALYZER_ERROR_SETTED = "AI_TOKEN_ANALYZER_ERROR_SETTED";
export const AI_TOKEN_ANALYZER_PROCESSING_SETTED = "AI_TOKEN_ANALYZER_PROCESSING_SETTED";
export const AI_NEW_TEXT_SETTED = "AI_NEW_TEXT_SETTED";
export const AI_NEW_TEXT_UNSETTED = "AI_NEW_TEXT_UNSETTED";

//REQUEST STATUS
export const RESULT = "RESULT";

//REQUEST STATUS
export const NOTIFICATION_SHOW = "NOTIFICATION_SHOW";
export const NOTIFICATION_HIDE = "NOTIFICATION_HIDE";
export const NOTIFICATION_SHOWED = "NOTIFICATION_SHOWED";
export const NOTIFICATION_HID = "NOTIFICATION_HID";

//REQUESTS CODES
export const REQUEST_ERROR = "REQUEST_ERROR";
export const PROCESSING = "PROCESSING";

// USER DATA
export const USER_DATA_CHANGED = "USER_DATA_CHANGED";
export const USER_DATA_INIT = "USER_DATA_INIT";
export const USER_DATA_UPDATED = "USER_DATA_UPDATED";

// UPGRADE
export const UPGRADE_SECTION_MAIN = "UPGRADE_SECTION_MAIN";
export const UPGRADE_SECTION_LEVEL = "UPGRADE_SECTION_LEVEL";
export const UPGRADE_SECTION_RESTORE = "UPGRADE_SECTION_RESTORE";
export const UPGRADE_SECTION_SUBSCRIPTION = "UPGRADE_SECTION_SUBSCRIPTION";
export const UPGRADE_SECTION_SUBSCRIPTION_BASIC = "UPGRADE_SECTION_SUBSCRIPTION_BASIC";
export const UPGRADE_SECTION_SUBSCRIPTION_PRO = "UPGRADE_SECTION_SUBSCRIPTION_PRO";
export const UPGRADE_SECTION_SUBSCRIPTION_PREMIUM = "UPGRADE_SECTION_SUBSCRIPTION_PREMIUM";
export const FREE = "free";
export const BASIC = "basic";
export const PRO = "pro";
export const PREMIUM = "premium";
export const RESTORE = "restore";
export const SUBSCRIPTION = "subscription";
export const AI_LEVEL = "ai_level";
export const AI_LEVEL_0 = "AI_LEVEL_0";
export const AI_LEVEL_1 = "AI_LEVEL_1";
export const AI_LEVEL_2 = "AI_LEVEL_2";
export const AI_LEVEL_3 = "AI_LEVEL_3";
export const AI_LEVEL_4 = "AI_LEVEL_4";
export const AI_LEVEL_5 = "AI_LEVEL_5";
export const UPGRADE_AI_LEVEL = "UPGRADE_AI_LEVEL";
export const UPGRADE_SUBSCRIPTION_BASIC = "UPGRADE_SUBSCRIPTION_BASIC";
export const UPGRADE_SUBSCRIPTION_PRO = "UPGRADE_SUBSCRIPTION_PRO";
export const UPGRADE_SUBSCRIPTION_PREMIUM = "UPGRADE_SUBSCRIPTION_PREMIUM";
export const RESTORE_ENERGY = "RESTORE_ENERGY";

// PRICES
export const FIELD_RESTORE = "restore";
export const XTR = "XTR";
export const TON = "TON";
export const TEXT = "TEXT";

// SELECT BLOCKCHAIN
export const ETH = "ETH";
export const BASE = "BASE";
export const BSC = "BSC";
export const BLOCKCHAIN_SETTED = "BLOCKCHAIN_SETTED";
export const ETH_BLOCKCHAIN = "Ethereum";
export const BASE_BLOCKCHAIN = "Base";
export const BSC_BLOCKCHAIN = "BSC";

export const PRICES = {
    AI_LEVEL_1: {
        XTR: 50,
        TON: 0.3
    },
    AI_LEVEL_2: {
        XTR: 100,
        TON: 0.6
    },
    AI_LEVEL_3: {
        XTR: 150,
        TON: 0.9
    },
    AI_LEVEL_4: {
        XTR: 250,
        TON: 1.5
    },
    AI_LEVEL_5: {
        XTR: 400,
        TON: 2.4
    },
    BASIC: {
        XTR: 1000,
        TON: 6.0
    },
    PRO: {
        XTR: 7500,
        TON: 45.0
    },
    PREMIUM: {
        XTR: 25000,
        TON: 150.0
    }
}

export const RESTORE_PRICES = {
    AI_LEVEL_0: {
        XTR: 7,
        TON: 0.03
    },
    AI_LEVEL_1: {
        XTR: 12,
        TON: 0.075
    },
    AI_LEVEL_2: {
        XTR: 25,
        TON: 0.15
    },
    AI_LEVEL_3: {
        XTR: 38,
        TON: 0.225
    },
    AI_LEVEL_4: {
        XTR: 62,
        TON: 0.375
    },
    AI_LEVEL_5: {
        XTR: 100,
        TON: 0.6
    },
    BASIC: {
        XTR: 250,
        TON: 1.5
    },
    PRO: {
        XTR: 187,
        TON: 11.25
    },
    PREMIUM: {
        XTR: 6250,
        TON: 37.5
    }
}

export const TOKEN_STATS_PNL = "TOKEN_STATS_PNL";
export const TOKEN_STATS_BUYS = "TOKEN_STATS_BUYS";
export const TOKEN_STATS_SELLS = "TOKEN_STATS_SELLS";
export const TOKEN_STATS_FIRST_TX = "TOKEN_STATS_FIRST_TX";
export const TOKEN_STATS_TRADE_TIME = "TOKEN_STATS_TRADE_TIME";
export const PORTFOLIO ="PORTFOLIO";
export const TOKEN_ANALYZER="TOKEN_ANALYZER";
export const TOKEN_ANALYZER_WALLET_STATS="TOKEN_ANALYZER_WALLET_STATS";
export const LEVEL_FEATURES = {

    WALLET_PROFIT: 0,
    WALLET_PNL: 0,
    WALLET_WIN_RATE: 1,
    WALLET_TRADES: 1,
    WALLET_AVERAGE_TRADE_TIME: 2,
    WALLET_AVERAGE_BUY_VOLUME: 2,

    TOKEN_STATS_PNL: 1,
    TOKEN_STATS_BUYS: 0,
    TOKEN_STATS_SELLS: 0,
    TOKEN_STATS_PROFIT: 0,
    TOKEN_STATS_FIRST_TX: 3,
    TOKEN_STATS_TRADE_TIME: 3,

    PORTFOLIO: 4,
    TOKEN_ANALYZER: 4,

    TOKEN_NAME: 4,
    TOKEN_WALLETS: 4,
    TOKEN_TRANSACTIONS: 5,
    TOKEN_TRADES: 5,
    TOKEN_AVERAGE_TRADE_TIME: 5,
    TOKEN_AVERAGE_BUY_VOLUME: 5,

    TOKEN_ANALYZER_WALLET_STATS: 5
}

export const CHECK_WALLET_PAUSES_TRY_NUMBER = 10;
export const CHECK_WALLET_PAUSES = [3000, 3000, 3000, 3000, 3000, 5000, 10000, 10000, 10000, 10000];

export const TOKEN_ANALYZER_TRY_NUMBER = 10;
export const TOKEN_ANALYZER_PAUSES = [5000, 5000, 10000, 10000, 30000, 30000, 30000, 30000, 30000, 30000];